import { getBasePath } from '@educator/config/basePath'
import { Button, IconChevronLeftDefault } from '@mc/design-system'
import { i18nInstance as globalNavI18n } from '@mc/global-navigation'
import { getSubjectsList } from '../../data/subjects'
import { paths } from '../../utils/paths'

const GLOBAL_NAV_NS = '@mc/global-navigation'

interface SubjectsSectionProps {
  onHideSubjectsSection: () => void
}

export const SubjectsSection = ({
  onHideSubjectsSection,
}: SubjectsSectionProps) => {
  const basePath = getBasePath()

  return (
    <div className='mc-px-4'>
      <Button
        className='mc-p-3 mc-my-5'
        onClick={onHideSubjectsSection}
        kind='tertiary'
        symmetrical
      >
        <IconChevronLeftDefault
          size='sm'
          srText={globalNavI18n.t('nav.cta.back', { ns: GLOBAL_NAV_NS })}
        />
      </Button>
      <div className='mc-corners--md mc-p-4 mc-bg-container-tint-medium'>
        <ul>
          {getSubjectsList().map((subject) => (
            <li key={subject.slug} className='mc-mb-4'>
              <a href={`${basePath}${paths.subjects}/${subject.slug}`}>
                {subject.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
